export default __webpack_public_path__ + "static/artifakt-element-bold-ea51933fc97d5d5b3591936d9d3f7a1f.ttf";